import { useMutation, useQueryClient } from '@tanstack/react-query';
import { issuesApi } from '../api/issuesApi';

/**
 * Hook for deleting an issue with React Query
 * Handles cache invalidation after deletion
 * 
 * @param {Object} options - Optional callbacks
 * @param {Function} options.onSuccess - Callback called on successful deletion (data, issueKey) => void
 * @param {Function} options.onError - Callback called on error (error) => void
 */
export const useDeleteIssue = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess: onSuccessCallback, onError: onErrorCallback } = options;

  return useMutation({
    mutationFn: (issueKey) => issuesApi.deleteIssue(issueKey),
    
    onSuccess: (data, issueKey) => {
      queryClient.setQueryData(['issues'], (oldIssues = []) => {
        return oldIssues.filter(issue => issue.key !== issueKey);
      });
      
      queryClient.removeQueries({ queryKey: ['issue', issueKey] });
      queryClient.invalidateQueries({ queryKey: ['issues'] });
      
      if (onSuccessCallback) {
        onSuccessCallback(data, issueKey);
      }
    },
    onError: (error) => {
      console.error('Error deleting issue:', error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    }
  });
};

